<div class="breadcrumb-container">
    <a class="breadcrumb-icon mr-3" (click)="sidenavCollapse()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
            <path d="M1 7H19M1 1H19M1 13H19" stroke="black" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
    </a>
    <div class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs$ | async">

        <a [routerLink]="breadcrumb.url" style="font-size: 22px;">
            {{ breadcrumb.label }}
        </a>
    </div>
</div>